export const GET_INFOMATION_STORE_DETAIL_ACTION =
	"GET_INFOMATION_STORE_DETAIL_ACTION";
export const SET_INFOMATION_STORE_DETAIL_ACTION =
	"SET_INFOMATION_STORE_DETAIL_ACTION";

export const UPLOAD_IMAGE_PROFILE_ACTION = "UPLOAD_IMAGE_PROFILE_ACTION";

export const UPDATE_INFOMATION_STORE_ACTION = "UPDATE_INFOMATION_STORE_ACTION";
